<template>
  <svg width="24" height="24" viewBox="0 0 24 24" class="fill-current" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 2C6.47714 2 2 6.47714 2 12C2 17.5229 6.47714 22 12 22C17.5229 22 22 17.5229 22 12C22 6.47714 17.5229 2 12 2ZM12 3.93548C16.4569 3.93548 20.0645 7.54238 20.0645 12C20.0645 16.4569 16.4576 20.0645 12 20.0645C7.54306 20.0645 3.93548 16.4576 3.93548 12C3.93548 7.54306 7.54238 3.93548 12 3.93548ZM17.6534 9.18819L16.7447 8.27214C16.5565 8.08242 16.2501 8.08117 16.0604 8.26939L10.3607 13.9233L7.94976 11.4927C7.76157 11.303 7.4552 11.3018 7.26548 11.49L6.34939 12.3987C6.15968 12.5869 6.15843 12.8932 6.34665 13.083L10.0072 16.7731C10.1954 16.9629 10.5017 16.9641 10.6915 16.7759L17.6507 9.8725C17.8404 9.68427 17.8416 9.3779 17.6534 9.18819Z"
    />
  </svg>
</template>

<script>
export default {
  name: 'SuccessIcon'
}
</script>
